<template>
  <div class="mb-2">
    <!-- Loading Spinner -->
    <div class="d-flex justify-content-center align-items-center py-1" v-if="querySpinner">
      <span class="spinner-border spinner-border-md highlightLoader" role="status" aria-hidden="true"></span>
      <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
    </div>
    <!-- Query Label -->
    <b-row class="mx-1 mt-2"> Query </b-row>
    <!-- Condition fields and Add to Query, Apply, and Refresh buttons -->
    <b-row class="pt-2">
      <b-col class="col-sm-3">
        <b-form-select v-model="property" class="propStyle">
          <template #first>
            <b-form-select-option :value="null" disabled>
              Property
            </b-form-select-option>
          </template>
          <b-form-select-option v-for="(prop, i) in properties" :key="i" :value="prop">
            {{ prop }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col class="col-sm-2">
        <b-form-select v-model="operator" id="operatorSelect" class="propStyle">
          <template #first>
            <b-form-select-option :value="null" disabled>
              Operator
            </b-form-select-option>
          </template>
          <b-form-select-option v-for="(op, i) in operators" :key="i" :value="op">
            {{ op }}
          </b-form-select-option>
        </b-form-select>
      </b-col>
      <b-col class="col-sm-2">
        <b-form-input placeholder="Value" v-model="valueFirst" class="propStyle" />
      </b-col>
      <b-col class="col-sm-2 filter_value_2" v-if="this.operator == 'BETWEEN'">
        <b-form-input placeholder="Value" v-model="valueSecond" name="valueSecond" class="propStyle"
          :hidden="this.operator != 'BETWEEN'" />
      </b-col>
      <b-col class="col-sm-4">
        <b-link variant="ansi-button" @click="addWhere()" class="mx-3">
          Add To Query
        </b-link>
        <b-button @click="generateQuery()" class="btn mmp-button mx-3" variant="btn-primary">
          APPLY
        </b-button>
        <b-button @click="refresh()" class="btn mmp-button mx-3" variant="btn-primary">
          Refresh
        </b-button>
      </b-col>
    </b-row>
    <!-- Set conditions -->
    <b-row v-for="(condition, i) in conditions" :key="i" class="my-2">
      <hr class="hr-small" />
      <b-col class="col-md-3 mx-1"> {{ condition.property }}</b-col>
      <b-col class="col-md-2 mx-1"> {{ condition.operator }}</b-col>
      <b-col class="col-md-2 mx-1"> {{ condition.valueFirst }}</b-col>
      <b-col class="col-md-2 mx-1"> {{ condition.valueSecond }} </b-col>
      <b-col class="col-md-2 mx-1">
        <b-link class="danger" @click="removeCondition(i)">
          Remove Condition
        </b-link>
      </b-col>
    </b-row>
    <hr class="hr" />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_QueryConstructor',
  props: [
    'comp',
    'fromdate',
    'getConditions',
    'getFilterApiUrl',
    'getPropsApiUrl',
    'isAdmin',
    'jdayData',
    'reOpened',
    'spinner',
    'todate',
    'user',
    'tableName',
    'selset',
    'apiUrl',
    'fieldImages',
    'currentANSIPartNumber'
  ],
  data() {
    return {
      conditions: [],
      operator: null,
      operators: ['<', '>', '=', '<>', '<=', '>=', 'BETWEEN'],
      properties: [],
      property: null,
      valueFirst: null,
      valueSecond: null,
      querySpinner: false,
    }
  },
  methods: {
    addWhere() {
      let usingBetween = this.operator == 'BETWEEN'
      let validValueSecond = usingBetween && this.valueSecond != null
      if (
        this.property != null &&
        this.operator != null &&
        (!usingBetween || validValueSecond)
      ) {
        /* Only push condition if property and operator aren't null.
        If usingBetween is true, valueSecond must also not be null. */
        this.conditions.push({
          property: this.property,
          operator: this.operator,
          valueFirst: this.valueFirst == null ? '' : this.valueFirst,
          valueSecond: usingBetween ? this.valueSecond : null
        })

        // Clear data variables after adding condition
        this.property = null
        this.operator = null
        this.valueFirst = null
        this.valueSecond = null
      } else {
        this.$bvToast.toast(
          'Property and Operator fields must be filled out.',
          {
            title: 'Error Adding Condition to Query',
            toaster: 'b-toaster-top-center'
          }
        )
      }
    },
    generateQuery() {
      this.querySpinner = true
      if (sessionStorage.token) {
        switch (this.comp) {
          case 'DPR_FI':
            let filteredImages = this.fieldImages.filter(img => {
              return this.conditions.every(cond => {
                let parsedInputVal = cond.property == 'upload_date' ? new Date(cond.valueFirst).getTime() : cond.valueFirst
                let parsedImgVal = cond.property == 'upload_date' ? new Date(String(img.upload_date).split('T')[0]).getTime() : img[cond.property]
                switch (cond.operator) {
                  case "=":
                    return parsedImgVal === parsedInputVal;
                  case "!=":
                    return parsedImgVal !== parsedInputVal;
                  case ">":
                    return parsedImgVal > parsedInputVal;
                  case ">=":
                    return parsedImgVal >= parsedInputVal;
                  case "<":
                    return parsedImgVal < parsedInputVal;
                  case "<=":
                    return parsedImgVal <= parsedInputVal;
                  case 'BETWEEN':
                    return parsedImgVal >= parsedInputVal && parsedImgVal <= parsedInputVal;
                  default:
                    throw new Error(`Unsupported operator: ${operator}`);
                }
              });
            });
            this.$emit('filter_images', filteredImages)
            this.querySpinner = false;
            break;
          case 'DPR':
            if (sessionStorage.token) {
              axios
                .get(process.env.API_LOCATION + '/api/dpr/custom_query/', {
                  method: 'GET',
                  headers: {
                    'x-auth-token': sessionStorage.token
                  },
                  params: {
                    conds: this.conditions,
                    fromdate: this.fromdate,
                    todate: this.todate,
                    isAdmin: this.isAdmin,
                    extent: this.user.extent
                  }
                })
                .then(response => {
                  const content = response
                  if (content.errors) {
                    console.log('DPR API Call Error: ' + content.errors)
                  } else {
                    this.$emit('applyCustomQuery', {
                      rows: content.data.rows || [],
                      cond: this.conditions
                    })
                    this.querySpinner = false
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
            break
          case 'HDT':
            this.$emit('startSpinner')
            if (sessionStorage.token) {
              axios
                .get(
                  process.env.API_LOCATION + '/api/drive_tracking/custom_query',
                  {
                    method: 'GET',
                    headers: {
                      'x-auth-token': sessionStorage.token
                    },
                    params: {
                      conds: this.conditions,
                      current_julian_day: this.jdayData[0],
                      current_julian_day_minus_x: this.jdayData[1]
                    }
                  }
                )
                .then(response => {
                  const content = response
                  if (content.errors) {
                    console.log(
                      'Drive Tracking API Call Error: ' + content.errors
                    )
                  } else {
                    this.$emit('applyCustomQuery', {
                      rows: content.data.rows || [],
                      cond: this.conditions
                    })
                    this.querySpinner = false
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
            break
          case 'ANSI':
            axios
              .get(this.getFilterApiUrl, {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  conds: this.conditions
                }
              })
              .then(response => {
                const content = response
                if (content.errors) {
                  console.log('ANSI filtering API Call Error: ' + content.errors)
                } else {
                  this.$emit('applyCustomQuery', {
                    rows: content.data.rows || [],
                    cond: this.conditions
                  })
                  this.querySpinner = false
                }
              })
              .catch(function (error) {
                console.log(error)
              })
            break
          case 'Intersections':
            axios
              .get(this.getFilterApiUrl, {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  conds: this.conditions
                }
              })
              .then(response => {
                const content = response
                if (content.errors) {
                  console.log('ANSI Intersections filtering API Call Error: ' + content.errors)
                } else {
                  this.$emit('applyCustomQuery', {
                    rows: content.data.rows || [],
                    cond: this.conditions
                  })
                  this.querySpinner = false
                }
              })
              .catch(function (error) {
                console.log(error)
              })
            break
          case 'Biased':
            axios
              .get(process.env.API_LOCATION + `/api/${this.apiUrl}/biasedFilterFeatureTable`, {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  conds: this.conditions,
                  selset: this.selset,
                  partNumber: this.currentANSIPartNumber.part_number,
                  tableName: this.tableName
                }
              })
              .then(response => {
                const content = response
                if (content.errors) {
                  console.log('Biased ANSI filtering API Call Error: ' + content.errors)
                } else {
                  this.$emit('applyCustomQuery', {
                    rows: content.data.rows || [],
                    cond: this.conditions
                  })
                  this.querySpinner = false
                }
              })
              .catch(function (error) {
                console.log(error)
              })
            break
        }
      } else {
        console.log('No User Token.')
      }
    },
    removeCondition(e) {
      // Removes most recently added condition
      this.conditions.splice(e, 1)
    },
    refreshHDT() {
      this.querySpinner = true
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/drive_tracking/drive_tracking',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                current_julian_day: this.jdayData[0],
                seven_julian_days_ago: this.jdayData[1]
              }
            }
          )
          .then(response => {
            const content = response
            if (content.errors) {
              console.log('Drive Tracking API Call Error: ' + content.errors)
            } else {
              this.$emit('applyCustomQuery', {
                rows: content.data.rows || [],
                cond: this.conditions
              })
              this.querySpinner = false
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    refresh() {
      this.conditions = []
      if (this.comp == 'HDT') {
        this.refreshHDT()
      } else {
        this.generateQuery()
      }
    }
  },
  mounted() {
    if (sessionStorage.token) {
      switch (this.comp) {
        case 'DPR_FI':
          this.properties = [
            'dpr_id', 'upload_date', 'username'
          ]
          break;
        case 'ANSI':
          axios
            .get(this.getPropsApiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            })
            .then(response => {
              this.properties = []
              const content = response.data
              if (!content.errors) {
                for (let column in content) {
                  let columnName
                  switch (content[column].name) {
                    case 'Overall':
                    case 'overall':
                      columnName = 'status'
                      break
                    case 'pkey':
                      columnName = 'id'
                      break
                    case 'state_name':
                      columnName = 'region'
                      break
                    case 'id_':
                      columnName = 'segment_id'
                      break
                    default:
                      columnName = content[column].name
                      break
                  }
                  this.properties.push(columnName)
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          break
        case 'DPR':
          axios
            .get(process.env.API_LOCATION + '/api/dpr/query_constructor/', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                fromdate: this.fromdate,
                todate: this.todate,
                isAdmin: this.isAdmin,
                extent: this.user.extent
              }
            })
            .then(response => {
              const content = response.data.fields
              if (!content.errors) {
                this.properties = []
                for (let column in content) {
                  let columnName = content[column].name
                  if (columnName != 'id') {
                    this.properties.push(columnName)
                  }
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          break
        case 'HDT':
          axios
            .get(
              process.env.API_LOCATION +
              '/api/drive_tracking/query_constructor/',
              {
                method: 'GET',
                headers: {
                  'x-auth-token': sessionStorage.token
                }
              }
            )
            .then(response => {
              const content = response.data.fields
              if (!content.errors) {
                this.properties = []
                for (let column in content) {
                  let columnName = content[column].name
                  if (columnName != 'id') {
                    this.properties.push(columnName)
                  }
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          break
        case 'Intersections':
          axios
            .get(this.getPropsApiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            })
            .then(response => {
              this.properties = []
              const content = response.data
              if (!content.errors) {
                for (let column in content) {
                  let columnName
                  switch (content[column].name) {
                    case 'Overall':
                    case 'overall':
                      columnName = 'status'
                      break
                    case 'pkey':
                      columnName = 'id'
                      break
                    case 'state_name':
                      columnName = 'region'
                      break
                    case 'id_':
                      columnName = 'segment_id'
                    default:
                      columnName = content[column].name
                      break
                  }
                  this.properties.push(columnName)
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          break
        case 'Biased':
          axios
            .get(process.env.API_LOCATION + `/api/${this.apiUrl}/biasedFilterProps`, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                tableName: this.tableName
              }
            })
            .then(response => {
              this.properties = []
              const content = response.data
              if (!content.errors) {
                for (let column in content) {
                  let columnName
                  switch (content[column].name) {
                    case 'overall':
                      columnName = 'status'
                      break
                    default:
                      columnName = content[column].name
                      break
                  }
                  this.properties.push(columnName)
                }
              }
            })
            .catch(function (error) {
              console.log(error)
            })
          break
      }
    }
    if (this.getConditions != [] && this.getConditions != null) {
      this.conditions = this.getConditions
    }
  },
  watch: {
    conditions: function (newValue, oldValue) {
      this.generateQuery()
    },
    reOpened: function (newValue) {
      if (newValue) {
        this.generateQuery()
      }
    },
    selset: function () {
      this.conditions = []
    }
  }
}
</script>
